import { useLive } from "../state/use-live.js";
import { storage } from "../state/storage.js";
import type { Settings } from "@roqeet/core";
import { normalizeLocale, type Locale } from "./locales.js";
import { translate, type TKey } from "./strings.js";

/**
 * 현재 UI 로케일과 번역 함수를 반환하는 훅. Settings.locale을 반응형으로 구독해
 * (useTheme와 동일 패턴, 결정 #13) 언어를 바꾸면 화면이 즉시 갱신된다.
 *
 * 반환: { locale, t }. t(key)는 현재 로케일로 번역(누락 시 en-US → ko 폴백).
 */
export function useT(): { locale: Locale; t: (key: TKey, params?: Record<string, string | number>) => string } {
  const settings = useLive<Settings | undefined>(() => storage.liveSettings(), []);
  const locale = normalizeLocale(settings?.locale);
  return { locale, t: (key: TKey, params?: Record<string, string | number>) => translate(locale, key, params) };
}
